<p-dialog
  header="Size Guide"
  [(visible)]="visible"
  [closable]="true"
  [modal]="true"
  [style]="{ width: '750px' }"
  [draggable]="false"
  [resizable]="false"
>
  @if (groups().length === 0) {
    <p>
      We don't have specific sizing information for this product right now. Contact us—we're happy
      to help you find the perfect fit.
    </p>
  }

  @for (group of groups(); track $index) {
    <div class="mb-4">
      <table class="size-guide-table" style="width: 100%; border-collapse: collapse">
        <thead>
          <tr>
            <th style="border-bottom: 1px solid #ccc; padding: 0.5rem; text-align: left">
              <!--              Specification-->
            </th>
            @for (sz of group.sizes; track sz) {
              <th style="border-bottom: 1px solid #ccc; padding: 0.5rem; text-align: left">
                {{ sz }}
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (spec of group.specs; track spec.id) {
            <tr>
              <td style="padding: 0.5rem">{{ spec.specification_type }}</td>

              @for (sz of group.sizes; track sz) {
                <td style="padding: 0.5rem">
                  {{ findValue(spec.size_guide_sizes, sz) ?? '—' }}
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <ng-template #footer>
    <app-button label="Close" buttonStyle="outlined" (handleClick)="close()"></app-button>
  </ng-template>
</p-dialog>
